// The Activity Log's period selector, matching /financial-control.
//
// Same control (FilterDropdown), same variant and height, same row-2 slot — so the two
// pages present a period the same way instead of one using a bordered chip and the other
// a legacy date-range bar in its own toolbar.
import React, { useMemo } from "react";
import FilterDropdown from "../../components/ui-components/FilterDropdown";
import { HeaderPortal } from "../../components/ui-components/HeaderSlot.jsx";
// The dayjs wrapper, the same hook ActivityLog reads, so the selector and the list agree
// on the stored window's type rather than one of them coercing.
import { useFilterStoreWithDayjsDates } from "../../store/filterStore.js";
import { periodOptions, monthFromDate, monthRange } from "./activityPeriod";

const ActivityPeriodSelector = () => {
  const { startDate, setStartDate, setEndDate } = useFilterStoreWithDayjsDates();

  // Rebuilt only when the month changes rather than on every render: the list is empty
  // most of the time and dayjs() twelve times per keystroke is pure waste.
  const options = useMemo(() => periodOptions(), []);
  const value = monthFromDate(startDate);

  const handleChange = (month) => {
    const range = monthRange(month);
    if (!range) return;
    setStartDate(range.startDate);
    setEndDate(range.endDate);
  };

  return (
    <HeaderPortal slot="row2-right">
      <FilterDropdown
        ariaLabel="Reporting period"
        value={value}
        onChange={handleChange}
        options={options}
        minWidth={160}
        height={32}
        variant="tertiary"
      />
    </HeaderPortal>
  );
};

export default ActivityPeriodSelector;
